import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';

const IncomeWelcomeSectionOverride = fr.metaOverride({ base: BaseOverride });

export default IncomeWelcomeSectionOverride;
